import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  class: "item"
}
const _hoisted_4 = {
  key: 0,
  class: "item"
}
const _hoisted_5 = ["href"]

import { ref, computed } from 'vue';
	import { AnnualReviewDetails } from '@/models/loans';
	import { AnnualReviewStatusTypes } from '@/types/annual-review';
	import OverrideModal from '@/components/loan/annual-review/OverrideModal.vue';
	import AnnualReviewStatus from '@/components/loan/annual-review/AnnualReviewStatus.vue';
	import PermissionsWrapper from '@/components/wrappers/PermissionsWrapper.vue';
	import { Permissions, PermissionLevels } from '@/models/permissions';

	
export default /*@__PURE__*/_defineComponent({
  __name: 'DetailsCard',
  props: {
    cardTitle: {},
    referenceId: {},
    applicationUrl: {},
    details: {},
    creditPullTypeId: {},
    onReloadAnnualReviewAsync: { type: Function }
  },
  setup(__props: any) {

	const props = __props;

	const viewingOverride = ref(false);

	const closeOverrideModal = () => (viewingOverride.value = false);
	const openOverrideModal = () => (viewingOverride.value = true);

	const overrideLabel = computed(() =>
		props.details.annualReviewOverrides.length > 0 ? 'View Override' : '+ Add Override'
	);

	const showOverride = computed(() => {
		const validStatuses = [AnnualReviewStatusTypes.INITIALLY_FAILED, AnnualReviewStatusTypes.DECLINED];

		const inValidStatus = validStatuses.includes(props.details.annualReviewStatusId);
		const existingOverride = props.details.annualReviewOverrides.length > 0;

		return inValidStatus || existingOverride;
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(__props.cardTitle), 1)
    ]),
    _createVNode(AnnualReviewStatus, {
      annualReview: __props.details,
      onReloadAnnualReviewAsync: __props.onReloadAnnualReviewAsync
    }, null, 8, ["annualReview", "onReloadAnnualReviewAsync"]),
    _createVNode(PermissionsWrapper, {
      permissionIds: [_unref(Permissions).AnnualReview],
      permissionLevel: _unref(PermissionLevels).Update
    }, {
      default: _withCtx(() => [
        (showOverride.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "label" }, "Override", -1)),
              _createElementVNode("a", {
                class: "value action",
                onClick: openOverrideModal
              }, _toDisplayString(overrideLabel.value), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["permissionIds", "permissionLevel"]),
    (__props.applicationUrl && __props.referenceId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "label" }, "View Application", -1)),
          _createElementVNode("a", {
            class: "value action",
            href: __props.applicationUrl,
            target: "_blank"
          }, _toDisplayString(__props.referenceId), 9, _hoisted_5)
        ]))
      : _createCommentVNode("", true),
    (viewingOverride.value)
      ? (_openBlock(), _createBlock(OverrideModal, {
          key: 1,
          annualReviewId: __props.details.id,
          loanId: __props.details.loanId,
          overrides: __props.details.annualReviewOverrides,
          creditPullTypeId: __props.creditPullTypeId,
          onOverrideSuccessAsync: __props.onReloadAnnualReviewAsync,
          onClose: closeOverrideModal
        }, null, 8, ["annualReviewId", "loanId", "overrides", "creditPullTypeId", "onOverrideSuccessAsync"]))
      : _createCommentVNode("", true)
  ]))
}
}

})